/**
 * Check if user has filled Singapore job preferences
 * @param {Object} countryPreference - User's country preference object from Redux state
 * @returns {boolean} - Returns true if SG preferences are filled, false otherwise
 */
export const hasSGPreferencesFilled = (countryPreference) => {
  if (!countryPreference) {
    return false;
  }

  // Try both uppercase and lowercase keys
  const sgRelocationPreference =
    countryPreference?.relocationPreferences?.SG ||
    countryPreference?.relocationPreferences?.sg;
  const sgRightToWork =
    countryPreference?.rightToWork?.SG || countryPreference?.rightToWork?.sg;

  // Check if relocation preferences are defined
  if (!sgRelocationPreference) {
    return false;
  }

  // Check if relocation preferences have been set
  // User must have selected one of: relocate, remote, or not interested (both false)
  const hasRelocationPreference =
    sgRelocationPreference.relocate !== undefined &&
    sgRelocationPreference.remote !== undefined;

  if (!hasRelocationPreference) {
    return false;
  }

  // If user selected "not interested" (both false), they only need relocation preference
  const isNotInterested =
    sgRelocationPreference.relocate === false &&
    sgRelocationPreference.remote === false;

  if (isNotInterested) {
    return true;
  }

  // For users interested in SG jobs, check if right to work has been set
  if (!sgRightToWork) {
    return false;
  }

  const hasRightToWork =
    sgRightToWork.localCitizen !== undefined &&
    sgRightToWork.openToSponsor !== undefined &&
    sgRightToWork.visaOrEmploymentPass !== undefined;

  return hasRightToWork;
};
